import React, { useState, useEffect } from "react";
import "./checkout.css";
import Navbar from "../layout/nav/navbar/Navbar";
import Footer from "../layout/Footer/Footer";

function CheckOut() {
  const [cartItems, setCartItems] = useState([]);
  const [customerData, setCustomerData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    state: "",
    zip: "",
  });

  useEffect(() => {
    // Fetch the cart data from localStorage
    const storedCart = localStorage.getItem("incart");
    if (storedCart) {
      setCartItems(JSON.parse(storedCart)); // Parse the cart data
    }
  }, []);

  // Handle input changes for customer data
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCustomerData({
      ...customerData,
      [name]: value,
    });
  };

  const handleCheckout = () => {
    console.log("Proceeding to checkout with data:", customerData);
    // Add your checkout logic (API calls, etc.)
  };

  return (
    <>
      <Navbar />
     
      <div className="cart-page">
        <div className="checkout-section">
          <h3>Shipping Details</h3>
          <form className="checkout-form">
            <label>
              Name:
              <input
                type="text"
                name="name"
                value={customerData.name}
                onChange={handleInputChange}
                required
              />
            </label>
            <label>
              Email:
              <input
                type="email"
                name="email"
                value={customerData.email}
                onChange={handleInputChange}
                required
              />
            </label>
            <label>
              Phone:
              <input
                type="tel"
                name="phone"
                value={customerData.phone}
                onChange={handleInputChange}
                required
              />
            </label>
            <label>
              Address:
              <input
                type="text"
                name="address"
                value={customerData.address}
                onChange={handleInputChange}
                required
              />
            </label>
            <label>
              City:
              <input
                type="text"
                name="city"
                value={customerData.city}
                onChange={handleInputChange}
                required
              />
            </label>
            <label>
              State:
              <input
                type="text"
                name="state"
                value={customerData.state}
                onChange={handleInputChange}
                required
              />
            </label>
            <label>
              Zip Code:
              <input
                type="text"
                name="zip"
                value={customerData.zip}
                onChange={handleInputChange}
                required
              />
            </label>
          </form>

          <div className="cart-summary">
            <h3>Cart Summary</h3>
            <p>
              Subtotal: ₹
              {cartItems.reduce(
                (total, item) => total + item.ProductPrice * item.quantity,
                0
              )}
            </p>
            <button className="checkout-btn" onClick={handleCheckout}>
              Pay Now
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CheckOut;
